const apiConfig = {
    // apiRoot: 'https://idmapi.ddev.site/api/v1',
    // apiRoot: 'https://127.0.0.1:58303/api/v1',
    apiRoot: 'https://idm-api.mxm.agency/api/v1',
    // uploadsRoot: 'https://idmapi.ddev.site/uploads',
    uploadsRoot: 'https://idm-api.mxm.agency/uploads',
};

export default apiConfig;
